<template>
    <q-markup-table separator="cell" :bordered="bordered" wrap-cells :dense="dense">
        <tbody>
            <tr>
                <td>
                    <q-item>
                        <q-item-section avatar class="gt-xs"><q-icon name="mdi-microsoft" /></q-item-section>
                        <q-item-section>Operating System</q-item-section>
                    </q-item>
                </td>
                <td v-html="sysReq.system" />
            </tr>
            <tr>
                <td>
                    <q-item>
                        <q-item-section avatar class="gt-xs"><q-icon name="mdi-chip" /></q-item-section>
                        <q-item-section>Processor</q-item-section>
                    </q-item>
                </td>
                <td v-html="sysReq.processor" />
            </tr>
            <tr>
                <td>
                    <q-item>
                        <q-item-section avatar class="gt-xs"><q-icon name="mdi-memory" /></q-item-section>
                        <q-item-section> Memory </q-item-section>
                    </q-item>
                </td>
                <td v-html="sysReq.memory" />
            </tr>
            <tr>
                <td>
                    <q-item>
                        <q-item-section avatar class="gt-xs"><q-icon name="mdi-harddisk" /></q-item-section>
                        <q-item-section> Disk Space </q-item-section>
                    </q-item>
                </td>
                <td v-html="sysReq.diskspace" />
            </tr>
            <tr>
                <td>
                    <q-item>
                        <q-item-section avatar class="gt-xs"><q-icon name="mdi-expansion-card" /></q-item-section>
                        <q-item-section> Video </q-item-section>
                    </q-item>
                </td>
                <td v-html="sysReq.video" />

            </tr>
            <tr v-if="sysReq.mouse">
                <td>
                    <q-item>
                        <q-item-section avatar class="gt-xs"><q-icon name="mdi-mouse" /></q-item-section>
                        <q-item-section> Mouse </q-item-section>
                    </q-item>
                </td>
                <td v-html="sysReq.mouse" />

            </tr>
        </tbody>
    </q-markup-table>

</template>
<script>
    export default {
        name: 'system-requirements-table',
        props: {
            sysReq: Object,
            dense: Boolean,
            bordered: Boolean,
        },
        data() {
            return {

            }
        },
    }
</script>
<style scoped>

    .q-item__section--avatar {
        min-width: 0 !important;
    }
</style>

